module.exports = __webpack_public_path__ + "static/media/render-skyna.8395df6d.png";